import lockScroll from '../__utils/lockScroll';

const ctaDropdownTriggers = document.querySelectorAll('.block-destination-cta__destination-dropdown');
const ctaDopdownWrappers = document.querySelectorAll('.block-destination-cta__destination');

const localeCta = {
    activeClass: 'active'
};

const CLOSECTA = 0;
const OPENCTA = 1;
let ctaState = CLOSECTA;

/**
 * Open cta dropdown.
 */
const openCta = (trigger) => {
    trigger.classList.add(localeCta.activeClass);
    ctaState = OPENCTA;
}

/**
 * Close cta dropdown.
 */
const closeCta = (trigger) => {
    trigger.classList.remove(localeCta.activeClass);
    ctaState = CLOSECTA;
}

/**
 * Logic for toggle cta dropdown.
 */
const toggleCta = (trigger) => {
    ctaState === CLOSECTA ? openCta(trigger.parentNode) : closeCta(trigger.parentNode);
}

/**
 * Initial actions. Add event listener.
 */
const dropdownCtaInitial = () => {
    if (ctaDopdownWrappers.length === 0) return;
    ctaDropdownTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            toggleCta(trigger);
        });
    });
}

/**
 * Hide cta dropdown on outside click.
 */
export const closeCtaDropdown = ({target}) => {
    if (ctaDopdownWrappers.length === 0) return;
    ctaDopdownWrappers.forEach(wrapper => {
        if ( wrapper.classList.contains(localeCta.activeClass) ) {
            if ( !(target === wrapper || wrapper.contains(target) ) ) {
                closeCta(wrapper);
            }
        }
    });
}

export default dropdownCtaInitial;
